import React, { useState } from 'react';
import './main-layout.scss';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/sidebar/Sidebar';
import TopNav from '../components/topnav/TopNav';

const MainLayout = ({ onLogout }) => {
    const [isOpen, setIsOpen] = useState(false); // Sidebar state

    const toggleSidebar = () => {
        setIsOpen(prev => !prev); // Toggle sidebar open/close
    };

    return (
        <>
            <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />
            <div className="main">
                <div className="main__content">
                    <TopNav onLogout={onLogout} /> {/* Pass onLogout to TopNav */}
                    <Outlet />
                </div>
            </div>
        </>
    );
};

export default MainLayout